import {isNotNil} from 'ramda';

import {BalloonVariantDraft} from '../types/BalloonVariantDraft';

type ConfiguredBalloonVariant = BalloonVariantDraft & {nominalRate: number; apr: number};

/** A balloon variant counts as configured — and therefore saveable — once both rates are filled in. */
export function isConfiguredBalloonVariant(
  variant: BalloonVariantDraft
): variant is ConfiguredBalloonVariant {
  return isNotNil(variant.nominalRate) && isNotNil(variant.apr);
}
